import { DefaultState } from 'store/reducers/types';

export const READ_JOBS_DATA_REQUEST = "READ_JOBS_DATA_REQUEST";
export const READ_JOBS_DATA_SUCCESS = "READ_JOBS_DATA_SUCCESS";
export const READ_JOBS_DATA_FAILURE = "READ_JOBS_DATA_FAILURE";

export interface JobsData {
  unfilledJobsCount: number;
};

export type JobsState = DefaultState & {
  contents?: JobsData;
};

interface ReadJobsDataRequest {
  type: typeof READ_JOBS_DATA_REQUEST;
};

interface ReadJobsDataSuccess {
  type: typeof READ_JOBS_DATA_SUCCESS,
  contents: JobsData;
}

interface ReadJobsDataFailure {
  type: typeof READ_JOBS_DATA_FAILURE;
}

export type JobsActionTypes = ReadJobsDataRequest | ReadJobsDataSuccess | ReadJobsDataFailure;